module.exports = __webpack_public_path__ + "img/shop_code.cb788d01.png";